import {
  getTelegramCloudItem,
  setTelegramCloudItem,
} from '@/utils/telegramCloudStorage'

export const INVITATION_CODE_KEY = 'invitation_code'

export async function getInvitationCode(defaultValue = '') {
  const value = await getTelegramCloudItem(INVITATION_CODE_KEY, defaultValue)
  return value ? String(value) : defaultValue
}

export async function setInvitationCode(code) {
  return setTelegramCloudItem(INVITATION_CODE_KEY, code ? String(code) : '')
}
